import { RefObject, useEffect } from 'react';

/**
 * `ref` may be a single element to treat as "inside", or a list of them
 * (e.g. a card plus a sibling toolbar rendered outside the card's own DOM
 * subtree) — a click inside any of them is not an outside click.
 */
export const useClickOutside = (
  ref: RefObject<Element | null> | RefObject<Element | null>[],
  callback: (event: MouseEvent) => void,
) => {
  useEffect(() => {
    const refs = Array.isArray(ref) ? ref : [ref];

    function handleOuterClick(event: MouseEvent) {
      if (
        event.target instanceof Node &&
        refs.every(r => !r.current?.contains(event.target as Node))
      ) {
        callback(event);
      }
    }

    document.addEventListener('mousedown', handleOuterClick);
    return () => {
      document.removeEventListener('mousedown', handleOuterClick);
    };
    // `ref` objects are stable across renders; an inline array literal is
    // not, so it is intentionally excluded to avoid resubscribing on every render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [callback]);

  return { ref };
};
